export default __webpack_public_path__ + "locales/bg/Ldap.json?hash=0aedd2e1fe9d21e25cefeeb67c1fc3db";